import storage from 'src/storage';

const PITTA_AUTHORIZE_KEY = 'pitta_authorize';

/**
 * Cached, non-secret facts about the signed-in user.
 *
 * This holds NO credential. The session itself is an HttpOnly cookie the browser
 * manages, and `GET /security/session` is the only authority on whether one
 * exists — this is just a cache so the UI can render an account name without a
 * round trip. Never put a token back in here: it was exactly that (a `user_pass`
 * in localStorage) which made a single XSS able to mint authorization codes.
 */
export interface IAuthorize {
  account: string;
  /**
   * Absolute Unix timestamp (seconds) when the session expires. Callers must
   * NOT pass the backend's `expires_in` (a duration) here — convert at the
   * boundary via `now + expires_in` before persisting.
   */
  expiresAt: number;
}

export const getAuthorizes = (): IAuthorize[] =>
  storage.getItem<IAuthorize[]>(PITTA_AUTHORIZE_KEY) ?? [];

export const setAuthorize = (newAuthorize: IAuthorize): void => {
  const authorizes = getAuthorizes();
  const filtered = authorizes.filter((auth) => auth.account !== newAuthorize.account);
  storage.saveItem(PITTA_AUTHORIZE_KEY, [...filtered, newAuthorize]);
};

export const removeAuthorize = (account: string): void => {
  const authorizes = getAuthorizes();
  const filtered = authorizes.filter((auth) => auth.account !== account);
  storage.saveItem(PITTA_AUTHORIZE_KEY, filtered);
};
